import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes, provideRouter, withViewTransitions } from "@angular/router";

const routes: Routes =
	[
		// admin
		{
			path: "",
			loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule)
		},

		// 404 page not found
		//----------------------------------------------------------
		{
			path: "**",
			redirectTo: "admin/notfound"
		}
	];

const routerOptions: ExtraOptions =
{
	useHash: false,
	anchorScrolling: 'enabled',
	scrollPositionRestoration: 'enabled',
	bindToComponentInputs: true
};

@NgModule({
	imports:
		[
			RouterModule.forRoot(routes, routerOptions)
		],
	exports: [RouterModule],
	providers:
		[
			// view transitions
			provideRouter(routes, withViewTransitions())
		]
})
export class AppRoutingModule { }
